(function () {
  var doubleClickTimeout = 500;

  // Helper function to bind touch or click based on the device
  this.BindClick = function (node, callback) {
    if ('ontouchstart' in document) {
      var event = null;
      node._wclClickListeners = {
        click: function (e) {
          if (event === null) {
            callback(e, node);
          } else {
            event = null;
          }
        },
        touchstart: function (e) {
          event = e;
        },
        touchend: function (e) {
          if (event) {
            callback(event, node);
          }
        },
        touchmove: function (e) {
          event = null;
        },
      };

      node.addEventListener('touchstart', node._wclClickListeners.touchstart);
      node.addEventListener('touchend', node._wclClickListeners.touchend);
      node.addEventListener('touchmove', node._wclClickListeners.touchmove);
    } else {
      node._wclClickListeners = {
        click: function (e) {
          callback(e, node);
        },
      };
    }

    node.addEventListener('click', node._wclClickListeners.click);
  };

  // Helper function to bind double touch or click based on the device
  this.BindDoubleClick = function (node, callback) {
    node._wclClickTimeout = null;

    if ('ontouchstart' in document) {
      var event = null;
      node._wclClickListeners = {
        click: function (e) {
          if (event === null) {
            if (node._wclClickTimeout) {
              callback(e, node);
              clearTimeout(node._wclClickTimeout);
              node._wclClickTimeout = null;
            } else {
              node._wclClickTimeout = setTimeout(
                function () {
                  clearTimeout(node._wclClickTimeout);
                  node._wclClickTimeout = null;
                }.bind(this),
                doubleClickTimeout
              );
            }
          } else {
            event = null;
          }
        },
        touchstart: function (e) {
          event = e;
        },
        touchend: function (e) {
          if (event) {
            if (node._wclClickTimeout) {
              callback(e, node);
              clearTimeout(node._wclClickTimeout);
              node._wclClickTimeout = null;
            } else {
              node._wclClickTimeout = setTimeout(
                function () {
                  clearTimeout(node._wclClickTimeout);
                  node._wclClickTimeout = null;
                }.bind(this),
                doubleClickTimeout
              );
            }
          }
        },
        touchmove: function (e) {
          event = null;
        },
      };

      node.addEventListener('touchstart', node._wclClickListeners.touchstart);
      node.addEventListener('touchend', node._wclClickListeners.touchend);
      node.addEventListener('touchmove', node._wclClickListeners.touchmove);
    } else {
      node._wclClickListeners = {
        click: function (e) {
          if (node._wclClickTimeout) {
            callback(e, node);
            clearTimeout(node._wclClickTimeout);
            node._wclClickTimeout = null;
          } else {
            node._wclClickTimeout = setTimeout(
              function () {
                clearTimeout(node._wclClickTimeout);
                node._wclClickTimeout = null;
              }.bind(this),
              doubleClickTimeout
            );
          }
        },
      };
    }

    node.addEventListener('click', node._wclClickListeners.click);
  };

  this.UnbindClick = function (node) {
    if (!node._wclClickListeners) {
      return;
    }

    node.removeEventListener('click', node._wclClickListeners.click);
    if ('ontouchstart' in document) {
      node.removeEventListener(
        'touchstart',
        node._wclClickListeners.touchstart
      );
      node.removeEventListener('touchend', node._wclClickListeners.touchend);
      node.removeEventListener('touchmove', node._wclClickListeners.touchmove);
    }
  };
}).bind(window.WorstCyclingLane)();
